import React, { useState } from 'react';
import { Box, Typography, useMediaQuery, useTheme, Modal, IconButton } from '@mui/material';
import Navbar from '../components/Navbar/Navbar';
import CloseIcon from '@mui/icons-material/Close';

// Iconos de redes sociales
import FacebookIcon from '../img/facebook.svg';
import InstagramIcon from '../img/instagram.svg';
import Youtube from '../img/youtube.svg';

// Imagen vertical (reemplaza con la imagen real si tienes una)
import SystemImage from '../img/systems/1.png';
import img2 from '../img/systems/2.jpg';
import img3 from '../img/systems/3.jpg';

const Systems = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const isSmallMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const [openModal, setOpenModal] = useState(false);
    const [selectedImage, setSelectedImage] = useState(null);

    const handleImageClick = (image) => {
        setSelectedImage(image);
        setOpenModal(true);
    };

    const handleCloseModal = () => {
        setOpenModal(false);
        setSelectedImage(null);
    };

    const socialMedia = [
        { icon: FacebookIcon, alt: 'Facebook', link: '#' },
        { icon: InstagramIcon, alt: 'Instagram', link: '#' },
        { icon: Youtube, alt: 'Youtube', link: '#' }
    ];

    const cardData = [
        {
            title: 'SISTEMAS AISLADOS',
            text: 'Enfocados en sitios lejanos donde no cuenten con el servicio eléctrico convencional, mediante el uso de baterías puedes tener el servicio de energía eléctrica de manera continua las 24 horas.',
            image: SystemImage
        },
        {
            title: 'SISTEMAS INTERCONECTADOS',
            text: 'Ideales para ahorrar en la factura de energía al inyectar el excedente a la red pública, funcionando en conjunto con el sistema eléctrico convencional.',
            image: img2
        },
        {
            title: 'SISTEMAS HÍBRIDOS',
            text: 'Enfocados en el ahorro y continuidad del servicio mediante la ayuda de baterías, especial cuando el servicio eléctrico convencional presenta fallas constantes.',
            image: img3
        }
    ];

    return (
        <Box sx={{ backgroundColor: '#313131', minHeight: '100vh' }}>
            <Navbar />

            <Box sx={{
                display: 'flex',
                flexDirection: isMobile ? 'column' : 'row',
                minHeight: 'calc(100vh - 64px)',
                p: isMobile ? 2 : 6,
                position: 'relative',
                overflow: 'hidden'
            }}>

                {/* Redes sociales */}
                <Box sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 3,
                    position: 'absolute',
                    left: 20,
                    top: '50%',
                    transform: 'translateY(-50%)',
                    zIndex: 2
                }}>
                    {socialMedia.map((social, index) => (
                        <Box
                            component="img"
                            key={index}
                            src={social.icon}
                            alt={social.alt}
                            sx={{
                                width: 40,
                                height: 40,
                                cursor: 'pointer',
                                transition: 'transform 0.3s',
                                '&:hover': {
                                    transform: 'scale(1.1)',
                                    filter: 'drop-shadow(0 0 5px #EBC848)'
                                }
                            }}
                        />
                    ))}
                </Box>

                {/* Cards de sistemas */}
                <Box sx={{
                    width: '100%',
                    ml: isMobile ? 0 : '80px',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: 6,
                    mt: isMobile ? 8 : 0
                }}>
                    <Box sx={{
                        display: 'flex',
                        flexDirection: isMobile ? 'column' : 'row',
                        gap: 4,
                        justifyContent: 'center',
                        alignItems: 'stretch',
                        width: '100%'
                    }}>
                        {cardData.slice(0, 2).map((card, i) => (
                            <Box key={i} sx={{
                                display: 'flex',
                                backgroundColor: '#313131',
                                borderRadius: 3,
                                boxShadow: '0 0 15px rgba(235, 200, 72, 0.3)',
                                width: isMobile ? '100%' : '45%',
                                p: 3,
                                position: 'relative',
                                overflow: 'hidden'
                            }}>
                                {/* Línea neon izquierda */}
                                <Box sx={{
                                    position: 'absolute',
                                    left: 0,
                                    top: 0,
                                    height: '100%',
                                    width: '6px',
                                    backgroundColor: '#EBC848',
                                    boxShadow: '0 0 15px #EBC848, 0 0 25px #EBC848',
                                    animation: 'neonPulse 4s infinite'
                                }} />

                                <Box sx={{ ml: 2 }}>
                                    <Typography variant="h5" sx={{
                                        fontFamily: 'Montserrat, sans-serif',
                                        fontWeight: 700,
                                        color: '#EBC848',
                                        mb: 2
                                    }}>
                                        {card.title}
                                    </Typography>

                                    {card.image && (
                                        <Box
                                            component="img"
                                            src={card.image}
                                            alt={card.title}
                                            onClick={() => handleImageClick(card.image)}
                                            sx={{
                                                width: '100%',
                                                height: 'auto',
                                                maxHeight: 200,
                                                objectFit: 'cover',
                                                borderRadius: 2,
                                                mb: 2,
                                                border: '4px solid #EBC848',
                                                boxShadow: '0 0 20px #EBC848',
                                                cursor: 'pointer',
                                                transition: 'transform 0.3s',
                                                '&:hover': {
                                                    transform: 'scale(1.02)'
                                                }
                                            }}
                                        />
                                    )}

                                    <Typography variant="body1" sx={{
                                        fontFamily: 'Montserrat, sans-serif',
                                        color: '#fff',
                                        fontSize: '1rem',
                                        lineHeight: 1.6
                                    }}>
                                        {card.text}
                                    </Typography>
                                </Box>
                            </Box>
                        ))}
                    </Box>

                    {/* Última tarjeta centrada */}
                    <Box sx={{
                        display: 'flex',
                        backgroundColor: '#313131',
                        borderRadius: 3,
                        boxShadow: '0 0 15px rgba(235, 200, 72, 0.3)',
                        width: isMobile ? '100%' : '50%',
                        p: 3,
                        position: 'relative'
                    }}>
                        <Box sx={{
                            position: 'absolute',
                            left: 0,
                            top: 0,
                            height: '100%',
                            width: '6px',
                            backgroundColor: '#EBC848',
                            boxShadow: '0 0 15px #EBC848, 0 0 25px #EBC848',
                            animation: 'neonPulse 4s infinite'
                        }} />
                        <Box sx={{ ml: 2 }}>
                            <Typography variant="h5" sx={{
                                fontFamily: 'Montserrat, sans-serif',
                                fontWeight: 700,
                                color: '#EBC848',
                                mb: 2
                            }}>
                                {cardData[2].title}
                            </Typography>
                            {cardData[2].image && (
                                <Box
                                    component="img"
                                    src={cardData[2].image}
                                    alt={cardData[2].title}
                                    onClick={() => handleImageClick(cardData[2].image)}
                                    sx={{
                                        width: '100%',
                                        height: 'auto',
                                        maxHeight: 200,
                                        objectFit: 'cover',
                                        borderRadius: 2,
                                        mb: 2,
                                        border: '4px solid #EBC848',
                                        boxShadow: '0 0 20px #EBC848',
                                        cursor: 'pointer',
                                        transition: 'transform 0.3s',
                                        '&:hover': {
                                            transform: 'scale(1.02)'
                                        }
                                    }}
                                />
                            )}
                            <Typography variant="body1" sx={{
                                fontFamily: 'Montserrat, sans-serif',
                                color: '#fff',
                                fontSize: '1rem',
                                lineHeight: 1.6
                            }}>
                                {cardData[2].text}
                            </Typography>
                        </Box>
                    </Box>
                </Box>
            </Box>

            {/* Modal para imagen ampliada */}
            <Modal
                open={openModal}
                onClose={handleCloseModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backdropFilter: 'blur(5px)'
                }}
            >
                <Box sx={{
                    position: 'relative',
                    outline: 'none',
                    maxWidth: '90vw',
                    maxHeight: '90vh'
                }}>
                    <IconButton
                        onClick={handleCloseModal}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                            color: '#EBC848',
                            backgroundColor: 'rgba(0, 0, 0, 0.5)',
                            '&:hover': {
                                backgroundColor: 'rgba(0, 0, 0, 0.7)'
                            },
                            zIndex: 1
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                    <Box
                        component="img"
                        src={selectedImage}
                        alt="Imagen ampliada"
                        sx={{
                            maxWidth: '100%',
                            maxHeight: '90vh',
                            objectFit: 'contain',
                            borderRadius: 2,
                            border: '4px solid #EBC848',
                            boxShadow: '0 0 30px rgba(235, 200, 72, 0.8)'
                        }}
                    />
                </Box>
            </Modal>

            {/* Animación neon */}
            <style>
                {`
          @keyframes neonPulse {
            0%, 100% {
              box-shadow: 0 0 10px #EBC848, 0 0 20px #EBC848;
            }
            50% {
              box-shadow: 0 0 25px #EBC848, 0 0 35px #EBC848;
            }
          }
        `}
            </style>
        </Box>
    );
};

export default Systems;